import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_07_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-07-01",
    "name": "悬垂举腿",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "lower-abs",
    "tips": ["核心发力带动腿部抬起", "不借力摆动"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "source": "私教跟练 · 第7期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-28224b44145306c93070abd7.mp4",
    "videoUrl": "/media/collections-20261008/videos/f7b37b8b77da41735a89102d.mp4",
    "targetMuscles": ["腹直肌下部"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-07-02",
    "name": "仰卧卷腹",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "upper-abs",
    "tips": ["肩胛骨离地即可", "感受上腹收缩"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": true,
    "source": "私教跟练 · 第7期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-40c6fca7d1a7fba75a335e44.mp4",
    "videoUrl": "/media/collections-20261008/videos/c052c5e6d6f4f1c90fd58672.mp4",
    "targetMuscles": ["腹直肌上部"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-07-03",
    "name": "健腹轮",
    "bodyPart": "abs",
    "equipment": "ab-wheel",
    "subCategory": "core",
    "tips": ["核心全程收紧", "不塌腰不弓背"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第7期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-c578a491ecf7cf7811e05850.mp4",
    "videoUrl": "/media/collections-20261008/videos/d3a65eba088bd42352596e43.mp4",
    "targetMuscles": ["核心肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
